/**
 * Categorie magazine, stile "Menu a tendina" (acf/magazine-categories):
 * il <details> si apre e chiude nativamente; qui si chiude anche con Esc
 * (riportando il focus sul summary) e con un clic fuori dal menu.
 */
export function initMagazineCategories() {
	const dropdowns = document.querySelectorAll( '.magazine-categories__dropdown' );
	if ( ! dropdowns.length ) return;

	dropdowns.forEach( ( details ) => {
		details.addEventListener( 'keydown', ( event ) => {
			if ( event.key !== 'Escape' || ! details.open ) return;
			details.open = false;
			details.querySelector( 'summary' ).focus();
		} );
	} );

	document.addEventListener( 'click', ( event ) => {
		dropdowns.forEach( ( details ) => {
			if ( details.open && ! details.contains( event.target ) ) {
				details.open = false;
			}
		} );
	} );
}
